import styled from "styled-components";
import { Menu as AntMenu } from "antd";
import {
  FONT_FAMILY,
  BASE_COLORS,
  FONT_SIZE_PX,
  FONT_WEIGHT,
} from "config/theme/constants";

export const Menu = styled(AntMenu)`
  background: ${BASE_COLORS.transparent};
  border-right: 0;
  width: auto;
  justify-content: center;

  .ant-menu-item .ant-menu-title-content a,
  .ant-menu-submenu .ant-menu-title-content a {
    font-size: ${FONT_SIZE_PX.xxxxs};
    color: ${BASE_COLORS.downRiver};
    font-weight: ${FONT_WEIGHT.normal};
    font-family: ${FONT_FAMILY.main};
  }

  .ant-menu-item .ant-menu-title-content,
  .ant-menu-submenu .ant-menu-title-content {
    line-height: normal;
  }

  .ant-menu-item,
  .ant-menu-submenu .ant-menu-submenu-title {
    padding: 8px 8px;
    display: flex;
    justify-content: center;
    white-space: break-spaces;
    height: auto;
    margin: 0 auto;
    width: 98%;
  }

  .ant-menu-submenu .ant-menu-submenu-arrow {
    display: none;
  }

  a {
    width: 100%;
    display: block;
  }

  .ant-menu-item,
  .ant-menu-submenu {
    margin-block: 0px;
    border-radius: 4px;

    svg {
      width: 18px;
      height: 18px;
    }
  }

  .ant-menu-item-icon {
    width: 1.25rem;
  }

  .ant-menu-submenu-expand-icon,
  .ant-menu-submenu-arrow,
  span[role="img"],
  a,
  .ant-menu-item,
  .ant-menu-submenu {
    color: var(--text-sider-secondary-color);
    fill: var(--text-sider-secondary-color);
  }

  .ant-menu-item:hover,
  .ant-menu-submenu-title:hover {
    .ant-menu-submenu-expand-icon,
    .ant-menu-submenu-arrow,
    span[role="img"],
    a,
    .ant-menu-item-icon,
    .ant-menu-title-content {
      color: var(--text-sider-primary-color);
      fill: var(--text-sider-primary-color);
    }
  }

  .ant-menu-submenu-selected {
    .ant-menu-submenu-title {
      color: var(--text-sider-primary-color);

      .ant-menu-submenu-expand-icon,
      .ant-menu-submenu-arrow,
      span[role="img"] {
        color: var(--text-sider-primary-color);
        fill: var(--text-sider-primary-color);
      }
    }
  }

  .ant-menu-item-selected {
    background-color: ${BASE_COLORS.curiousBlue} !important;
    border-radius: 4px;
    margin-block: 1px !important;
    width: 98%;
    margin: 0 auto;

    .ant-menu-title-content a {
      color: ${BASE_COLORS.white};
    }

    svg {
      fill: ${BASE_COLORS.white};
    }

    .ant-menu-submenu-expand-icon,
    .ant-menu-submenu-arrow,
    span[role="img"],
    .ant-menu-item-icon,
    a {
      color: var(--text-sider-primary-color);
      fill: var(--text-sider-primary-color);
    }
  }

  .ant-menu-item-active,
  .ant-menu-submenu-active .ant-menu-submenu-title {
    background-color: ${BASE_COLORS.curiousBlue} !important;
    border-radius: 4px;

    svg {
      fill: ${BASE_COLORS.white};
    }

    .ant-menu-title-content a {
      color: ${BASE_COLORS.white};
    }
  }
`;
